<div class="row">
  <div class="medium-12 mt-3 mb-3" style="padding: 10px 0 20px 0; background: #F5F5F5;border-radius: 5px;" *ngIf="strategies && strategies.length > 0">
    <div class="row">
      <div class="columns medium-4">
        <label>
          Mass Apply Fields
          <app-tpiq-select-dropdown [includeNone]="false" [setData]="applyOptions" [setPlaceHolder]="'Select option'" [setSearchKey]="'name'" [setValueKey]="'name'" (onValueSelect)="setApplyOptionValue($event)" [setDefaultValue]="selectedOption"></app-tpiq-select-dropdown>
        </label>
      </div>
      <div class="columns medium-3">
        <div *ngIf="selectedOption == 'Payor'">
          <label>
            Apply Payor
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="clients" [setPlaceHolder]="'Select Payor'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setClientValue($event)" [setDefaultValue]=""></app-tpiq-select-dropdown>
          </label>
        </div>
        <div *ngIf="selectedOption == 'Fed Associated With'">
          <label>
            Apply Fed Associated With
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="associatedWith" [setPlaceHolder]="'Fed Associated With'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setAssociatedValue($event)" [setDefaultValue]=""></app-tpiq-select-dropdown>
          </label>
        </div>
        <div *ngIf="selectedOption == 'State Associated With'">
          <label>
            Apply State Associated With
            <app-tpiq-select-dropdown [includeNone]="false" [setData]="allStateAssociatedData" [setPlaceHolder]="'State Associated With'" [setSearchKey]="'name'" [setValueKey]="'id'" (onValueSelect)="setAssociatedValue($event, 'state')" [setDefaultValue]=""></app-tpiq-select-dropdown>
          </label>
        </div>
        <div *ngIf="selectedOption == 'Plan Amount'">
          <label>
            Apply Plan Amount
            <input class="float-left input-field" placeholder="Plan Amount" type="text" [(ngModel)]="applyOptionObject.amount"
                   model-numeral [locale]="'USD'" [format]="'$0,0'"/>
          </label>
        </div>
        <div *ngIf="selectedOption == 'Begin Year'">
          <label>
            Apply Begin Year
            <app-tpiq-input-search [setData]="years" [setColName]="''" [setPlaceHolder]="'Begin Year'" [setMasterRow]="''" [setSearchKey]="'name'" [setValueKey]="'id'"
                                [setDefaultValue]="" (onValueSelect)="selectYear($event, 'sinceYear')"></app-tpiq-input-search>

          </label>
        </div>
        <div *ngIf="selectedOption == 'End Year'">
          <label>
            Apply End Year
            <app-tpiq-input-search [setData]="years" [setColName]="''" [setPlaceHolder]="'End Year'" [setMasterRow]="''" [setSearchKey]="'name'" [setValueKey]="'id'"
                                [setDefaultValue]="" (onValueSelect)="selectYear($event, 'toYear')"></app-tpiq-input-search>

          </label>
        </div>
        <div *ngIf="selectedOption == 'Create Task Date'">
          <label>
            Apply Create Task Date
            <input class="float-left input-field" type="text" tpiq-custom-datepicker [attr.format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="applyOptionObject.goalDate"
                   placeholder="Create Task Date" (valueChanged)="updateGoalDate($event)"/>
          </label>
        </div>
      </div>
      <div class="columns medium-5">
        <button *ngIf="selectedOption" style="margin-bottom: 0;position: relative;top: 30px;" class="button small" (click)="applyOnTemplateStrategies()">Apply to all Strategies</button>
      </div>
    </div>
  </div>
  <div class="medium-12">
    <div class="indy-tables badge-tables tp-desc tracker-desc">
      <app-tracker-paginated-table [setObj]="taxStrategyTableData" *ngIf="hasStrategies" (onRowAction)="handleAction($event)"
                               (onInputSearchSelection)="optionSelected($event)" (onInputBlur)="updateInput($event)"></app-tracker-paginated-table>
    </div>
  </div>
</div>

